import { Navigate } from "react-router-dom";

import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  CashReceipt,
  ContentCashReceipt,
  AddCashReceipt,
  DetailCashReceipt,
  ImportCashReceipt,
} from "./pages";

const cashReceiptRoutes = [
  {
    path: "/finance",
    element: (
      <ProtectedRoute name="cash_receipt">
        <Navigate to="cash-receipt/balance" replace />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="finance" defaultTitle="breadcrumb.finance" />
    ),
  },
  {
    path: "/finance/cash-receipt",
    element: (
      <ProtectedRoute name="cash_receipt">
        <CashReceipt />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="cash_receipt"
        defaultTitle="cashReceipt.title"
      />
    ),
    children: [
      {
        path: "/finance/cash-receipt/balance",
        element: <ContentCashReceipt />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"cashReceipt.balance"} />
        ),
        children: [
          {
            path: "/finance/cash-receipt/balance/add",
            element: <AddCashReceipt />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/finance/cash-receipt/waiting-approval",
        element: <ContentCashReceipt />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"approval.waiting_approval"} />
        ),
        children: [
          {
            path: "/finance/cash-receipt/waiting-approval/add",
            element: <AddCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/finance/cash-receipt/waiting-approval/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/finance/cash-receipt/approved",
        element: <ContentCashReceipt />,
        breadcrumb: () => <TranslationBreadcrumb name={"approval.approved"} />,
        children: [
          {
            path: "/finance/cash-receipt/approved/add",
            element: <AddCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/finance/cash-receipt/approved/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/finance/cash-receipt/rejected",
        element: <ContentCashReceipt />,
        breadcrumb: () => <TranslationBreadcrumb name={"approval.rejected"} />,
        children: [
          {
            path: "/finance/cash-receipt/rejected/add",
            element: <AddCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/finance/cash-receipt/rejected/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/finance/cash-receipt/payment",
        element: <ContentCashReceipt />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"cashReceipt.payment"} />
        ),
        children: [
          {
            path: "/finance/cash-receipt/payment/add",
            element: <AddCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/finance/cash-receipt/payment/detail/:cashReceiptId",
            element: <DetailCashReceipt />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/finance/cash-receipt/import",
    element: (
      <ProtectedRoute name="cash_receipt_add">
        <ImportCashReceipt />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="cashReceipt.import_cash_receipt" />
    ),
  },
];

export default cashReceiptRoutes;
